import { createSelector } from '@reduxjs/toolkit'

import { MenuSliceState } from '../slices/menu.slice'

const selectMenu = (state: { menu: MenuSliceState }) => state.menu

export const selectMenuFilters = createSelector(
  selectMenu,
  menu => menu.filters
)
